import { RefreshCw } from 'lucide-react'
import { usePWAUpdate } from '@/context/PWAUpdateContext'

/**
 * "New version available — tap to update" toast. Appears when a new service
 * worker has downloaded and is waiting. Tapping applies it and reloads.
 * Non-dismissable by design (it's a one-tap action, not a nag) but small and
 * out of the way — above the mobile bottom bar, bottom-right on desktop.
 */
export function UpdatePrompt() {
  const { needRefresh, updateNow } = usePWAUpdate()

  if (!needRefresh) return null

  return (
    <div className="fixed inset-x-0 bottom-[calc(3.75rem+env(safe-area-inset-bottom))] z-[9996] px-3 pb-2 md:inset-x-auto md:bottom-4 md:right-4 md:max-w-sm md:px-0">
      <button
        onClick={updateNow}
        className="flex w-full items-center gap-3 rounded-xl border border-primary/40 bg-primary text-primary-foreground shadow-2xl px-4 py-3 text-left hover:bg-primary/90 transition-colors"
      >
        <RefreshCw className="h-5 w-5 shrink-0" />
        <span className="min-w-0 flex-1">
          <span className="block text-sm font-semibold">New version available</span>
          <span className="block text-xs opacity-90">Tap to update to the latest TrackMind</span>
        </span>
        <span className="shrink-0 rounded-md bg-primary-foreground/15 px-2.5 py-1 text-xs font-medium">
          Update
        </span>
      </button>
    </div>
  )
}
